<template>
  <div>
  <!--新页面：充电站登记-->
  <el-dialog title="快速建站" width="900px" :visible="newEditFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" :modal-append-to-body='false' :before-close="clearNewEditForm">
    <el-form :model="newEditForm" ref="newEditForm" :rules="newEditFormRules" size="mini">
      <el-col :span="12">
        <el-form-item label="运营商：" :label-width="formLabelWidth" prop="operatorId">
<!--          <el-select placeholder="运营商" v-model="newEditForm.operatorId">
            <el-option v-for="item in operatorForSelect" :key="item.id" :disabled="operatorDisable(item)"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>-->
          <el-cascader  size="mini"
                        placeholder="运营商"  filterable ref="cascader"
                        :options="this.setTreeDisable(this.operatorForSelect)"
                        :props="{ checkStrictly:true,expandTrigger:'hover'}"
                        :show-all-levels="false"
                        change-on-select
                        @change='handleChangeOperator'
                        v-model="newEditForm.operatorId">
          </el-cascader>
        </el-form-item>
      </el-col>
      <!--<el-col :span="12">
        <el-form-item label="二级运营商：" :label-width="formLabelWidth" prop="virtualId">
          <el-select placeholder="运营商" v-model="newEditForm.virtualId">
            <el-option v-for="item in operatorForSelect" :key="item.id"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>-->
      <el-col :span="12">
        <el-form-item label="充电站名称：" :label-width="formLabelWidth" prop="stationName">
          <el-input v-model="newEditForm.stationName" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="充电站类型：" :label-width="formLabelWidth" prop="stationType">
          <el-select placeholder="充电站类型" v-model="newEditForm.stationType">
            <el-option v-for="item in stationTypeData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="充电站状态：" :label-width="formLabelWidth" prop="stationStatus">
          <el-select placeholder="充电站状态" v-model="newEditForm.stationStatus">
            <el-option v-for="item in stationStatusData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="电站地区类型：" :label-width="formLabelWidth" prop="addressType">
          <el-select placeholder="地区类型" v-model="newEditForm.addressType">
            <el-option v-for="item in addressTypeData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="负责人：" :label-width="formLabelWidth" prop="dutyPerson">
          <el-input autocomplete="off" v-model="newEditForm.dutyPerson"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系电话：" :label-width="formLabelWidth" prop="dutyPersonPhone">
          <el-input autocomplete="off" v-model="newEditForm.dutyPersonPhone"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="单枪桩总数量：" :label-width="formLabelWidth" prop="oneGunNum">
          <el-input v-model="newEditForm.oneGunNum" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="双枪桩总数量：" :label-width="formLabelWidth" prop="secondGunNum">
          <el-input v-model="newEditForm.secondGunNum" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="三枪桩总数量：" :label-width="formLabelWidth" prop="threeGunNum">
          <el-input v-model="newEditForm.threeGunNum" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="四枪桩总数量：" :label-width="formLabelWidth" prop="fourGunNum">
          <el-input v-model="newEditForm.fourGunNum" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="所在省：" :label-width="formLabelWidth" prop="province">
          <el-input placeholder="上传站点地址后填充" disabled v-model="newEditForm.province" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所在市：" :label-width="formLabelWidth" prop="city">
          <el-input placeholder="上传站点地址后填充" disabled v-model="newEditForm.city" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="县/区：" :label-width="formLabelWidth" prop="area">
          <el-input placeholder="上传站点地址后填充" disabled v-model="newEditForm.area" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="经度：" :label-width="formLabelWidth" prop="longitude">
          <el-input placeholder="上传站点地址后填充" disabled autocomplete="off" id="longitude" v-model="newEditForm.longitude"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="纬度：" :label-width="formLabelWidth" prop="latitude">
          <el-input placeholder="上传站点地址后填充" disabled autocomplete="off" id="latitude" v-model="newEditForm.latitude"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="详细地址：" :label-width="formLabelWidth" prop="address">
          <el-input autocomplete="off" placeholder="点击按钮选择站点所在地址" id="address" v-model="newEditForm.address"></el-input>
          <el-button @click="showInnerForm">站点地址
            <i class="el-icon-upload el-icon--right"></i></el-button>
        </el-form-item>
      </el-col>
    </el-form>
    <!--footer -->
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" plain @click="clearNewEditForm">取 消</el-button>
      <el-button size="mini" plain type="primary" @click.native="newEditSubmit" :loading="newEditSubmitLoading">提交
      </el-button>
    </div>
  </el-dialog>
  <!--   地图组件   -->
  <el-dialog width="40%" :visible.sync="dialogInnerVisible">
    <!--快速搜索 form-->
    <el-form :model="innerForm" ref="innerForm" :inline="true" size="mini">
      <el-tabs v-model="innerFormName">
        <!--经纬坐标-->
        <el-tab-pane label="经纬坐标" name="coordinate">
          <el-row class="el_row_input row_input">
            <el-col :span="10" class="el_col_input">
              <el-form-item label="经度：">
                <el-input autocomplete="off" v-model="centerTemp.lng"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="2" class="el_col_input">
              <el-form-item label="纬度：">
                <el-input autocomplete="off" v-model="centerTemp.lat"></el-input>
              </el-form-item>
            </el-col>
            <!--                <el-col :span="2">-->
            <!--                  <el-form-item>-->
            <!--                    <el-button size="mini" class="el_search">搜索</el-button>-->
            <!--                  </el-form-item>-->
            <!--                </el-col>-->
          </el-row>
          <!--百度地图组件-->
          <div class="BaiduMap">
            <baidu-map class="map" :center="centerTemp" :zoom="15" :scroll-wheel-zoom="true"
                       :map-style="{styleJson:styleJson}"
                       map-type="BMAP_NORMAL_MAP" @click="getClickInfo">
              <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
                              :autoLocation="true"></bm-geolocation>
              <!--&lt;!&ndash;//添加一个小红点的，并将当前的经纬度写入数据中&ndash;&gt;-->
              <bm-marker :position="centerTemp"></bm-marker>
              <bm-control :offset="{width: '10px', height: '10px'}">
                <bm-auto-complete v-model="keyword" :sugStyle="{zIndex: 9999}">
                  <el-input size="mini" v-model="keyword" placeholder="请输入地名关键字"></el-input> <!-- 这里指代一个自定义搜索框组件 -->
                </bm-auto-complete>
              </bm-control>
              <bm-local-search :keyword="keyword" :auto-viewport="true"></bm-local-search>
            </baidu-map>
          </div>
          <!--内部对话框底部当前位置-->
          <el-row class="el_row_input rows_input">
            <el-col :span="24" class="el_col_input">
              <el-form-item>
                <label style="color: sienna;font-weight: bold" v-text="addressTemp"></label>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" plain @click="dialogInnerVisible =false ">取 消</el-button>
      <el-button size="mini" plain type="primary" @click="confirmAddress">提交</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
  import {validateInput,isInteger,validatePhoneThree} from '../../../../common/validator'
  export default {
    name: "quickAdd",
    data() {
      return {
        newEditFormRules: {
          operatorId: [{required: true, message: '请选择运营商', trigger: 'blur'}],
          stationName:[{required: true, message: '请输入站名称', trigger: 'blur'},{validator: function (rule, value, callback) {
                validateInput(rule, value, callback,0,15,true,true,false,false,false,false,false)
              }, trigger: 'blur'}],
          stationType: [{required: true, message: '请选择站类型', trigger: 'blur'}],
          stationStatus: [{required: true, message: '请选择站状态', trigger: 'blur'}],
          longitude: [{required: true, message: '请上传充电站地址', trigger: 'blur'}],
          latitude: [{required: true, message: '请上传充电站地址', trigger: 'blur'}],
          address: [{required: true, message: '请选择充电站所在地址', trigger: 'blur'},{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,127,true,false,false,false,false,false,false)
            }, trigger: 'blur'}],
          addressType: [{required: true, message: '请选择地区类型', trigger: 'blur'}],
          dutyPerson: [{required: true, message: '请输入负责人', trigger: 'blur'},{validator: function (rule, value, callback) {
                validateInput(rule, value, callback,0,10,true,true,false,false,true,false,false)
              }, trigger: 'blur'}],
          dutyPersonPhone: [{required: true, message: '请输入联系电话', trigger: 'blur'},{validator: validatePhoneThree, trigger: 'blur'}],
          oneGunNum: [{required: true, message: '请输入此站单枪口充电桩总数量', trigger: 'blur'},{validator: function (rule, value, callback) {
                validateInput(rule, value, callback,0,6,true,true,true,true,false,false,false)
              }, trigger: 'blur'}],
          secondGunNum: [{required: true, message: '请输入此站双枪口充电桩总数量', trigger: 'blur'},{validator: function (rule, value, callback) {
                validateInput(rule, value, callback,0,6,true,true,true,true,false,false,false)
              }, trigger: 'blur'}],
          threeGunNum: [{required: true, message: '请输入此站三枪口充电桩总数量', trigger: 'blur'},{validator: function (rule, value, callback) {
                validateInput(rule, value, callback,0,6,true,true,true,true,false,false,false)
              }, trigger: 'blur'}],
          fourGunNum: [{required: true, message: '请输入此站四枪口充电桩总数量', trigger: 'blur'},{validator: function (rule, value, callback) {
                validateInput(rule, value, callback,0,6,true,true,true,true,false,false,false)
              }, trigger: 'blur'}],
        },
        formLabelWidth: '150px',
        // 百度地图初始化数据
        dialogInnerVisible: false, // 内部对话框
        innerForm: {},
        innerFormName: 'coordinate',
        styleJson: [ // 百度地图自定义
          {
            'featureType': 'water',
            'elementType': 'all',
            'stylers': {
              'color': '#ffffff'
            }
          }
        ],
        baidumapSwitch: false,
        zoom: 16,
        location: '上海市',
        keyword: '',
        centerTemp: {
          lng: 121.384555, lat: 31.069087
        },
        // 设置center属性值
        provinceTemp: '',
        cityTemp: '',
        districtTemp: '',
        addressTemp: '',
      }
    },
    methods:{
      operatorDisable(item) {
        // 判断是否为潜在运营商
        const flag = (item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved')) ? true : false
        return flag
      },
      //对数据进行授权过滤
      setTreeDisable(val) {
        //对 treeList 进行递归操作，禁止选中unchecked和unapproved
        val && val.forEach(item => {
          if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
            item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
          }
          if (item.children) {
            this.setTreeDisable(item.children);
          }
        });
        return val;
      },
      handleChangeOperator(value) {
        let operatorId = value && value.length >0 ? value[value.length-1] : ''
        this.newEditForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
      },
      clearNewEditForm(){
        let _this = this
        console.log(this.newEditForm.id)
        if(this.newEditForm.id == null || this.newEditForm == '') {
          this.$confirm('是否要取消当前操作？').then(_ => {
            _this.$refs.newEditForm.clearValidate()
            _this.$emit('closeNewEditForm')
          }).catch(_ => {})
        }else {
          _this.$refs.newEditForm.clearValidate()
          _this.$emit('closeNewEditForm')
        }
      },
      showInnerForm() {
        this.centerTemp.lng = this.newEditForm.longitude == null ? 121.384555 : this.newEditForm.longitude
        this.centerTemp.lat = this.newEditForm.latitude == null ? 31.069087 : this.newEditForm.latitude
        this.provinceTemp = this.newEditForm.province
        this.cityTemp = this.newEditForm.city
        this.districtTemp = this.newEditForm.area
        this.addressTemp = this.newEditForm.address
        this.dialogInnerVisible = true
      },
      // 点击获取到当前经纬度
      getClickInfo(e) {
        const myGeo = new window.BMap.Geocoder()
        myGeo.getLocation(e.point, data => {
          if (data) {
            this.centerTemp = {lng: e.point.lng, lat: e.point.lat}
            this.provinceTemp = data.addressComponents.province
            this.cityTemp = data.addressComponents.city
            this.districtTemp = data.addressComponents.district
            this.addressTemp = data.address
          }
        })
      },
      confirmAddress() {
        //this.newEditForm.longitude = this.centerTemp.lng
        //this.newEditForm.latitude = this.centerTemp.lat
        this.newEditForm.province = this.provinceTemp
        this.newEditForm.city = this.cityTemp
        this.newEditForm.area = this.districtTemp
        // this.newEditForm.address = this.addressTemp
        this.$set(this.newEditForm, 'address', this.addressTemp);
        document.getElementById("address").focus();
        document.getElementById("address").blur();
        //this.$set(this.newEditForm, 'longitude', this.centerTemp.lat);
        //document.getElementById("longitude").blur();
        //document.getElementById("longitude").focus();
        this.$set(this.newEditForm, 'longitude', this.centerTemp.lng);
        this.$set(this.newEditForm, 'latitude', this.centerTemp.lat);
        this.$refs.newEditForm.clearValidate("longitude");
        this.$refs.newEditForm.clearValidate("latitude");
        this.dialogInnerVisible = false
      },
      newEditSubmit(){
        this.$emit('newEditSubmit',this.$refs.newEditForm)
      },
    },
    props:{
      newEditFormVisible:{
        type:Boolean,
        required:true
      },
      newEditForm:{},
      newEditSubmitLoading:false,
      operatorForSelect: '',
      stationTypeData:'',
      stationStatusData:'',
      addressTypeData:'',
      businessTypeData:'',
      YesNoEnumData:'',
      feesTakeUpPileData:'',
      fastOrSlowData:'',
      isCecData:''
    }
  }
</script>

<style lang="less" scoped>

  .BaiduMap {
    height: 300px;

    div {
      height: 300px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/siteManager/quickAdd.vue